export default class swipeHint {
  constructor() {
    this.swipeHint = null;
    this.boundTargets = new WeakSet(); // 重複イベント防止のため空のセットを用意
    this.init();
  }

  init() {
    this.tryBind(); // 初期DOMに対して即チェック

    const observer = new MutationObserver(this.tryBind.bind(this));
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  tryBind() {
    const hint = document.querySelector('.o-swipeHint');
    if (!hint) return;
    this.swipeHint = hint;


    document.querySelectorAll('.o-swipeHint-target').forEach((target) => {
      if (this.boundTargets.has(target)) return;

      target.addEventListener('touchstart', () => this.hideHint(), { passive: true, once: true });
      target.addEventListener('mouseenter', () => this.hideHint(), { once: true });
    
      // 重複イベント防止のため記録
      this.boundTargets.add(target);
    });
  }

  hideHint() {
    this.swipeHint?.classList.add('is-hidden');
  }
}
